import { IconButton, List, ListItem, ListItemIcon, ListItemText } from "@mui/material"
import Iconify from "../Iconify"
import getFileData from "../utils/getFileData"
import { fData } from "../utils/formatNumber"

export function AcceptedFiles({ files = [], onRemoveFile }) {
    return (
        <List dense>
            {files.map((file) => {
                const { path, size, name } = getFileData(file)
                return (
                    <ListItem
                        key={path}
                        secondaryAction={
                            <IconButton
                                aria-label="Remove file"
                                edge="end"
                                size="small"
                                onClick={() => onRemoveFile(file)}
                                data-cy="file-upload-item-clear"
                            >
                                <Iconify icon="ic:round-clear" />
                            </IconButton>
                        }
                        sx={{ border: 1, borderRadius: 1, borderColor: "grey.50032", p: 1, mt: 2 }}
                    >
                        <ListItemIcon>
                            <Iconify icon="mdi:file-document-outline" sx={{ width: 36, height: 36 }} />
                        </ListItemIcon>
                        <ListItemText
                            primaryTypographyProps={{
                                fontWeight: "fontWeightMedium",
                            }}
                            primary={name}
                            secondary={size ? fData(size) : ""}
                        />
                    </ListItem>
                )
            })}
        </List>
    )
}
